import "ulog";
import anylogger from "anylogger";

export default anylogger;
